export const menuConfig = {
  admin: [
    { icon: '📊', label: 'Dashboard', path: 'admin-dashboard' },
    { icon: '👥', label: 'Student Management', path: 'admin-students' },
    { icon: '👨‍🏫', label: 'Teacher Management', path: 'admin-teachers' },
    { icon: '🎯', label: 'Training Management', path: 'admin-training' },
    { icon: '📝', label: 'Student Attendance', path: 'admin-attendance' },
    { icon: '📋', label: 'Teacher Attendance', path: 'admin-teacher-attendance' },
    { icon: '📸', label: 'Attendance Collect Report', path: 'admin-attendance-collect-report' },
    // { icon: '📈', label: 'Attendance Analytics', path: 'admin-attendance-analytics' },
    { icon: '❗', label: 'Grievance Portal', path: 'admin-grievances' },
    { icon: '👤', label: 'HOD Portal', path: 'admin-hods' },
    { icon: '🎓', label: 'Internship Portal', path: 'admin-internships' },
    { icon: '🔬', label: 'Lab Management', path: 'admin-labs' },
    { icon: '🔐', label: 'Login Portal', path: 'admin-login-credentials' },
    { icon: '📋', label: 'Login Logs', path: 'admin-login-logs' },
    { icon: '🆔', label: 'Student Cards', path: 'admin-student-cards' },
    { icon: '📝', label: 'Exam Schedule', path: 'admin-exam-schedule' },
    { icon: '📅', label: 'Timetable', path: 'admin-timetable' },
    { icon: '📝', label: 'Assign Marks', path: 'admin-marks' },
    { icon: '📢', label: 'Notice Management', path: 'admin-notices' },
    { icon: '📚', label: 'E-Learning', path: 'admin-elearning' },
    { icon: '🏖️', label: 'Holiday Calendar', path: 'admin-holidays' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  teacher: [
    { icon: '📊', label: 'Dashboard', path: 'teacher-dashboard' },
    { icon: '👤', label: 'Profile', path: 'teacher-profile' },
    { icon: '✅', label: 'Attendance', path: 'teacher-attendance' },
    { icon: '📅', label: 'Time Table', path: 'teacher-timetable' },
    { icon: '📝', label: 'Requisition', path: 'teacher-requisition' },
    { icon: '✍️', label: 'Marks Submission', path: 'teacher-marks-submission' },
    { icon: '📚', label: 'Students Assignment', path: 'teacher-student-assignment' },
    { icon: '📒', label: 'Class Notes', path: 'teacher-class-notes' },
    { icon: '🎓', label: 'E-Learning', path: 'teacher-elearning' },
    { icon: '❗', label: 'Grievance', path: 'teacher-grievance' },
    { icon: '🏖️', label: 'Holiday Calendar', path: 'teacher-holidays' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  student: [
    { icon: '📊', label: 'Dashboard', path: 'student-dashboard' },
    { icon: '✅', label: 'View Full Attendance', path: 'student-attendance' },
    { icon: '👤', label: 'Student Details', path: 'student-profile' },
    { icon: '📷', label: 'Internship Attendance', path: 'student-internship' },
    { icon: '🆔', label: 'Student Cards', path: 'student-cards' },
    { icon: '📄', label: 'Forms', path: 'student-forms' },
    { icon: '📈', label: 'Marks Review', path: 'student-marks-review' },
    { icon: '📝', label: 'Assignments', path: 'student-assignments' },
    { icon: '❗', label: 'Grievance', path: 'student-grievance' },
    { icon: '📒', label: 'Class Notes', path: 'student-class-notes' },
    { icon: '🎓', label: 'E-Learning', path: 'student-elearning' },
    { icon: '📚', label: 'Library', path: 'student-library' },
    { icon: '🏖️', label: 'Holiday Calendar', path: 'student-holidays' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  hod: [
    { icon: '📊', label: 'Dashboard', path: 'hod-dashboard' },
    { icon: '👤', label: 'Profile', path: 'hod-profile' },
    { icon: '👁️', label: 'View Grievances', path: 'hod-grievances' },
    { icon: '🎓', label: 'Internship Attendance', path: 'hod-internship' },
    { icon: '🔬', label: 'Lab Review', path: 'hod-lab-review' },
    { icon: '👨‍🏫', label: 'Teacher Attendance', path: 'hod-teacher-attendance' },
    { icon: '📋', label: 'Review Requests', path: 'hod-review-requests' },
    { icon: '📦', label: 'Supply Applications', path: 'hod-supply-applications' },
    { icon: '📝', label: 'Requisition', path: 'hod-requisition' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  accounts: [
    { icon: '📊', label: 'Dashboard', path: 'accounts-dashboard' },
    { icon: '💰', label: 'Fee Management', path: 'accounts-fee-manage' },
    { icon: '📋', label: 'Fee Structures', path: 'accounts-fee-structures' },
    { icon: '📈', label: 'Manage Performance', path: 'accounts-performance' },
    { icon: '📜', label: 'Manage Work Completion Certificate', path: 'accounts-certificates' },
    { icon: '📋', label: 'Manage Work Orders', path: 'accounts-work-orders' },
    { icon: '🚐', label: 'Vendor Management', path: 'accounts-vendor-management' },
    { icon: '📦', label: 'Inventory Management', path: 'accounts-inventory' },
    { icon: '💰', label: 'Salary Counter', path: 'accounts-salary-counter' },
    { icon: '📑', label: 'Financial Reports', path: 'accounts-reports' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  parent: [
    { icon: '📊', label: 'Dashboard', path: 'Dashboard' },
    { icon: '🎓', label: 'Academic Performance', path: 'Academic Performance' },
    { icon: '💳', label: 'Fee Status', path: 'Fee Status' },
    { icon: '🏖️', label: 'Holidays & Events', path: 'Holidays & Events' },
    { icon: '🚨', label: 'Emergency Alert', path: 'Emergency Alert' },
    { icon: '🚪', label: 'Logout', path: 'Logout' }
  ],
  librarian: [
    { icon: '📊', label: 'Dashboard', path: 'library-dashboard' },
    { icon: '📚', label: 'Book Catalog', path: 'library-catalog' },
    { icon: '🏷️', label: 'Categories', path: 'library-categories' },
    { icon: '📖', label: 'Issue Books', path: 'library-issue' },
    { icon: '🔄', label: 'Return Books', path: 'library-return' },
    { icon: '👥', label: 'Members', path: 'library-members' },
    { icon: '📋', label: 'Book Requests', path: 'library-requests' },
    { icon: '⚠️', label: 'Overdue Books', path: 'library-overdue' },
    { icon: '💰', label: 'Fine Management', path: 'library-fines' },
    { icon: '🆕', label: 'New Arrivals', path: 'library-new-arrivals' },
    { icon: '🚪', label: 'Logout', path: 'logout' }
  ],
  examcell: [
    { icon: '📊', label: 'Dashboard', path: 'examcell-dashboard' },
    { icon: '🎫', label: 'Admit Card', path: 'examcell-admitcard' },
    { icon: '📋', label: 'Admit Format', path: 'examcell-admitformat' },
    { icon: '📝', label: 'Exam Form', path: 'examcell-examform' },
    { icon: '📄', label: 'Forms', path: 'examcell-forms' },
    { icon: '💰', label: 'Semester Fees', path: 'examcell-semesterfees' },
    { icon: '❗', label: 'Grievance', path: 'examcell-grievance' },
    { icon: '🚪', label: 'Logout', path: 'login' }
  ]
};
